import cn from 'classnames';
import { Label } from '@creditflowresearch/uilib/Badge/Label';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { IDealStatus } from '@/creditflowresearch/domain/vo/IDeal';

import styles from './dealStatus.module.scss';

const mapStatusToColor = {
  PRCD: '#4AB675',
  ANNC: '#5C74E8',
  ANCD: '#5C74E8',
  LNCH: '#29AAFF',
  GDNC: '#05C0F4',
  SPRD: '#5258FF',
  PMKT: '#5B97D7',
  MNDT: '#3E7EC3',
  IPT: '#007BFF',
  FILD: '#8B8BA0',
  '15-G': '#7883A1',
  RUMR: '#606C8B',
  PTPD: '#CC4D4D',
  CNCD: '#A74040',
};

const mapStatusToClassName = {
  PRCD: styles.statusLabelBorderPrcd,
  LNCH: styles.statusLabelBorderLnch,
  GDNC: styles.statusLabelBorderGdnc,
  SPRD: styles.statusLabelBorderSprd,
  ANNC: styles.statusLabelBorderAnnc,
  ANCD: styles.statusLabelBorderAnnc,
  PMKT: styles.statusLabelBorderPmkt,
  MNDT: styles.statusLabelBorderMndt,
  FILD: styles.statusLabelBorderFild,
  '15-G': styles.statusLabelBorderFifteenG,
  RUMR: styles.statusLabelBorderRumr,
  PTPD: styles.statusLabelBorderPtpd,
  CNCD: styles.statusLabelBorderCncd,
  IPT: styles.statusLabelBorderIpt,
};

const DealStatus = ({ status }: { status: IDealStatus }) => (
  <div className={ styles.statusCell } data-test="dealRowStatus">
    { status ? (
      <Tooltip content={ status?.name }>
        <Label
          className={ cn(styles.statusLabel, styles.label, mapStatusToClassName[status.abbreviation]) }
          textColor={ mapStatusToColor[status.abbreviation] || '#8c8c8c' }
          backgroundColor="transparent"
        >
          { status?.abbreviation }
        </Label>
      </Tooltip>
    ) : null }
  </div>
);

export default DealStatus;
